
import { config, debug, i18n, inject, observer, React, Route, RouteComponentProps, ui } from "aaa";
import { AliasDeleteUsernameSigning } from "components/alias/AliasDeleteUsernameSigning";
import { AliasDeleteUsernameSuccess } from "components/alias/AliasDeleteUsernameSuccess";
import { AliasManageUsername } from "components/alias/AliasManageUsername";
import { AliasManageUsernameSigning } from "components/alias/AliasManageUsernameSigning";
import { AliasManageUsernameSuccess } from "components/alias/AliasManageUsernameSuccess";
import externalInterfaceStore, { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute, replaceRoute } from "stores/RouterFunctions";
import auth from "stores/AuthStore";
import { history } from "stores/RouterStore";
import { ErrorScreen } from "../../common/ErrorScreen";
import { LoginManagementActivateGeorgeId } from "../LoginManagementActivateGeorgeId";
import { SIdentitySettingsAddAdditionalDesktopInfo } from "./SIdentitySettingsAddAdditionalDesktopInfo";
import { SIdentitySettingsAddDeviceCategory } from "./SIdentitySettingsAddDeviceCategory";
import { SIdentitySettingsAddDeviceSigning } from "./SIdentitySettingsAddDeviceSigning";
import { SIdentitySettingsAddDeviceSuccess } from "./SIdentitySettingsAddDeviceSuccess";
import { SIdentitySettingsAddDeviceSummary } from "./SIdentitySettingsAddDeviceSummary";
import { SIdentitySettingsCode } from "./SIdentitySettingsCode";
import { SIdentitySettingsDeleteSigning } from "./SIdentitySettingsDeleteSigning";
import { SIdentitySettingsDeleteSuccess } from "./SIdentitySettingsDeleteSuccess";
import { SIdentitySettingsHomeScreen } from "./SIdentitySettingsHomeScreen";
import { SIdentitySettingsLimit } from "./SIdentitySettingsLimit";
import { SIdentitySettingsLimitSigning } from "./SIdentitySettingsLimitSigning";
import { SIdentitySettingsLimitSuccess } from "./SIdentitySettingsLimitSuccess";
import { SIdentitySettingsStore } from "./SIdentitySettingsStore";
import { SIdentitySettingsRoutes } from "./SIdentitySettingsRoutes";
import { GidSettingsRoutes } from "../gidSettings/GidSettingsRoutes";
import { CardTanSettingsRoutes } from "../cardTanSettings/CardTanSettingsRoutes";

type IProps = RouteComponentProps<{}> & i18n.InjectedIntlProps & {
    externalInterfaceStore: ExternalInterfaceStore;
};

@i18n.injectIntl
@inject("externalInterfaceStore")
@observer
export default class SIdentitySettingsContainer extends React.Component<IProps, {}> {
    store: SIdentitySettingsStore;

    constructor(props: any) {
        super(props);
        this.store = new SIdentitySettingsStore();
    }

    async componentDidMount() {
        try {
            if (auth.authorized) {
                await this.store.loadSettings();
            }

            const authorizationType = externalInterfaceStore.settings?.authorizationType;

            if (history.location.pathname.startsWith(SIdentitySettingsRoutes.LIMIT)) {
                if (history.location.pathname !== SIdentitySettingsRoutes.LIMIT) {
                    replaceRoute(SIdentitySettingsRoutes.LIMIT);
                }
            } else if (history.location.pathname.startsWith(SIdentitySettingsRoutes.ONBOARDING_LIMIT)) {
                if (authorizationType === "SID") {
                    if (history.location.pathname !== SIdentitySettingsRoutes.ONBOARDING_LIMIT) {
                        replaceRoute(SIdentitySettingsRoutes.ONBOARDING_LIMIT);
                    }

                    await this.store.loadLimits();
                    return;
                } else {
                    if (authorizationType === "GEORGE_TOKEN") {
                        replaceRoute(GidSettingsRoutes.ONBOARDING_LIMIT);
                        return;
                    } else if (authorizationType === "CARDTAN") {
                        replaceRoute(CardTanSettingsRoutes.ONBOARDING_LIMIT);
                        return;
                    }
                }
            } else if (history.location.pathname !== SIdentitySettingsRoutes.ROOT) {
                pushRoute(SIdentitySettingsRoutes.ROOT);
            }

            if (authorizationType !== "SID") {
                replaceRoute(SIdentitySettingsRoutes.ERROR_SIGNING_METHOD);
                return;
            }

            if (auth.authorized) {
                await this.store.load();
                if (!this.store.status) {
                    debug.log("### failed to load status");
                    pushRoute("/error");
                }
            }
        } catch (error) {
            debug.log("### Container.componentDidMount() Failed to load data", error);
            if (!config.DEBUG) {
                pushRoute("/error");
            }
        }
    }

    withStore(Component: any) {
        return () => <Component {...this.props} store={this.store} />;
    }

    withAliasStore(Component: any) {
        return () => <Component {...this.props} store={this.store.aliasStore} />;
    }

    withMessage(Component: any, message: string) {
        return () => <Component {...this.props} useWebVersion variant="error" message={message} />;
    }

    render() {
        const pages = [
            {
                path: "limit",
                title: ui.__("sidentity.navbar.selectLimit")
            },
            {
                path: "success",
                title: ui.__("sidentity.navbar.summary")
            }
        ];

        return (
            <div>
                {/* {!this.store.activationPending && <NavigationBar
                    pages={pages}
                    basePath="/login-management/sid"
                    path={this.props.location.pathname}
                    backToBase
                />} */}

                <Route exact path={this.props.match.path} render={this.withStore(SIdentitySettingsHomeScreen)} />
                <Route path={SIdentitySettingsRoutes.USERNAME} component={this.withAliasStore(AliasManageUsername)} />
                <Route path={SIdentitySettingsRoutes.USERNAME_SIGNING} component={this.withAliasStore(AliasManageUsernameSigning)} />
                <Route path={SIdentitySettingsRoutes.USERNAME_SUCCESS} component={this.withAliasStore(AliasManageUsernameSuccess)} />
                <Route path={SIdentitySettingsRoutes.DELETE_USERNAME_SIGNING} component={this.withAliasStore(AliasDeleteUsernameSigning)} />
                <Route path={SIdentitySettingsRoutes.DELETE_USERNAME_SUCCESS} component={this.withAliasStore(AliasDeleteUsernameSuccess)} />
                <Route path={SIdentitySettingsRoutes.DELETE_SIGNING} component={this.withStore(SIdentitySettingsDeleteSigning)} />
                <Route path={SIdentitySettingsRoutes.DELETE_SUCCESS} component={this.withStore(SIdentitySettingsDeleteSuccess)} />
                <Route path={SIdentitySettingsRoutes.CODE} component={this.withStore(SIdentitySettingsCode)} />
                <Route exact path={SIdentitySettingsRoutes.ONBOARDING_LIMIT} component={this.withStore(SIdentitySettingsLimit)} />
                <Route path={SIdentitySettingsRoutes.ONBOARDING_LIMIT_SIGNING} component={this.withStore(SIdentitySettingsLimitSigning)} />
                <Route path={SIdentitySettingsRoutes.ONBOARDING_LIMIT_SUCCESS} component={this.withStore(SIdentitySettingsLimitSuccess)} />
                <Route exact path={SIdentitySettingsRoutes.LIMIT} component={this.withStore(SIdentitySettingsLimit)} />
                <Route path={SIdentitySettingsRoutes.LIMIT_SIGNING} component={this.withStore(SIdentitySettingsLimitSigning)} />
                <Route path={SIdentitySettingsRoutes.LIMIT_SUCCESS} component={this.withStore(SIdentitySettingsLimitSuccess)} />
                <Route path={SIdentitySettingsRoutes.ADD_DEVICE_CATEGORY} component={this.withStore(SIdentitySettingsAddDeviceCategory)} />
                <Route path={SIdentitySettingsRoutes.ADD_DEVICE_SUMMARY} component={this.withStore(SIdentitySettingsAddDeviceSummary)} />
                <Route path={SIdentitySettingsRoutes.ADD_DEVICE_SIGNING} component={this.withStore(SIdentitySettingsAddDeviceSigning)} />
                <Route path={SIdentitySettingsRoutes.ADD_DEVICE_SUCCESS} component={this.withStore(SIdentitySettingsAddDeviceSuccess)} />
                <Route path={SIdentitySettingsRoutes.ADD_DESKTOP_DEVICE_INFO} component={this.withStore(SIdentitySettingsAddAdditionalDesktopInfo)} />
                <Route path={SIdentitySettingsRoutes.ACTIVATE_GEORGE_ID} component={this.withStore(LoginManagementActivateGeorgeId)} />
                <Route
                    path={SIdentitySettingsRoutes.ERROR_SIGNING_METHOD}
                    render={this.withMessage(ErrorScreen, ui.__("sidentitySettings.error.signingMethod"))}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/loginManagement/sIdentitySettings/SIdentitySettingsContainer.tsx